/* Mama's Daily product page: gallery, pack picker, add-on, stock line, sticky bar and calculator.
   Add to cart is handled by the original product page's md-pdp.js (the [data-md-atc] button and
   [data-md-addon-check] box), so adding, the cart drawer, the add-on and error messages behave
   exactly as they do on the original template. This file only keeps the button's variant in step. */
(function () {
  'use strict';
  if (window.__mdhProductLoaded) return;
  window.__mdhProductLoaded = true;

  function formatMoney(cents, format) {
    var fmt = format || '£{{amount}}';
    var value = (Number(cents) || 0) / 100;
    function withDelimiters(n, decimals, thousands, decimal) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimals ? decimal : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelimiters(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(value, 0, '.', ',');
        case 'amount_with_space_separator': return withDelimiters(value, 2, ' ', ',');
        default: return withDelimiters(value, 2, ',', '.');
      }
    });
  }

  /* ---------------- Main product section ---------------- */
  function initProduct(root) {
    if (!root || root.dataset.mdhReady) return;
    root.dataset.mdhReady = 'true';
    var dataEl = root.querySelector('script[data-mdh-product]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var variants = data.variants;
    var moneyFormat = data.moneyFormat;

    var slides = root.querySelector('.mdh-pdp__slides');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.mdh-pdp__thumb'));
    var countEl = root.querySelector('.mdh-pdp__count');
    var slideEls = slides ? Array.prototype.slice.call(slides.children) : [];

    function goTo(index) {
      if (!slides || !slideEls[index]) return;
      slides.scrollTo({ left: slideEls[index].offsetLeft, behavior: 'smooth' });
    }
    function currentIndex() {
      if (!slides || !slides.clientWidth) return 0;
      return Math.round(slides.scrollLeft / slides.clientWidth);
    }
    function syncGallery() {
      var i = currentIndex();
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', String(n === i)); });
      if (countEl) countEl.textContent = (i + 1) + ' / ' + slideEls.length;
    }
    if (slides) {
      var raf;
      slides.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(syncGallery); }, { passive: true });
      thumbs.forEach(function (t, n) { t.addEventListener('click', function () { goTo(n); }); });
      root.querySelectorAll('[data-mdh-gallery]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var i = currentIndex() + (btn.dataset.mdhGallery === 'next' ? 1 : -1);
          if (i < 0) i = slideEls.length - 1;
          if (i >= slideEls.length) i = 0;
          goTo(i);
        });
      });
    }

    var form = null;
    var addBtnEl = root.querySelector('[data-md-atc]');
    var idInput = { value: addBtnEl ? addBtnEl.dataset.variant : '' };
    var qtyInput = null;
    var addBtn = addBtnEl;
    var addLabel = root.querySelector('[data-mdh-add-label]');
    var nowEls = document.querySelectorAll('[data-mdh-now="' + data.sectionId + '"]');
    var wasEls = document.querySelectorAll('[data-mdh-was="' + data.sectionId + '"]');
    var pctEls = root.querySelectorAll('[data-mdh-pct]');
    var nameEls = document.querySelectorAll('[data-mdh-variant-name="' + data.sectionId + '"]');
    var sticky = document.querySelector('[data-mdh-sticky="' + data.sectionId + '"]');
    var addon = root.querySelector('.mdh-addon input');
    var itemsBox = root.querySelector('[data-mdh-items]');

    function selected() {
      var id = Number(idInput.value);
      for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
      return variants[0];
    }
    function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }

    function syncItems() {
      if (!itemsBox) return;
      itemsBox.innerHTML = '';
      if (!addon || !addon.checked) return;
      var rows = [[idInput.value, qty()], [addon.value, 1]];
      rows.forEach(function (row, i) {
        ['id', 'quantity'].forEach(function (key, k) {
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'items[' + i + '][' + key + ']';
          input.value = row[k];
          itemsBox.appendChild(input);
        });
      });
    }

    function render() {
      var v = selected();
      var q = qty();
      nowEls.forEach(function (el) { el.textContent = formatMoney(v.price, moneyFormat); });
      wasEls.forEach(function (el) {
        el.textContent = v.compare > v.price ? formatMoney(v.compare, moneyFormat) : '';
        el.hidden = !(v.compare > v.price);
      });
      pctEls.forEach(function (el) {
        var pct = v.compare > v.price ? Math.round(((v.compare - v.price) * 100) / v.compare) : 0;
        el.hidden = !pct;
        var amount = formatMoney(Math.max(0, v.compare - v.price), moneyFormat).replace(/[.,]00(?=\D*$)/, '');
        el.textContent = (el.dataset.mdhPct || 'Save [pct]%').replace('[pct]', pct).replace('{pct}', pct).replace('[amount]', amount);
      });
      nameEls.forEach(function (el) { el.textContent = v.title; });
      var urg = root.querySelector('[data-mdh-urg]');
      if (urg) {
        var threshold = Number(urg.dataset.threshold) || 0, full = Number(urg.dataset.full) || 100, sold = Number(urg.dataset.sold) || 0;
        var left = typeof v.stock === 'number' ? v.stock : 0;
        var low = threshold > 0 && left > 0 && left <= threshold;
        var lowEl = urg.querySelector('[data-mdh-urg-low]'), bar = urg.querySelector('[data-mdh-urg-bar]');
        if (lowEl) { lowEl.hidden = !low; var n = lowEl.querySelector('[data-mdh-urg-left]'); if (n) n.textContent = left; }
        if (bar) { bar.hidden = !low; var pct = Math.min(100, Math.round((left * 100) / full)); if (low && pct < 3) pct = 3; bar.firstElementChild.style.width = pct + '%'; }
        urg.hidden = !(sold > 0 || low);
      }
      root.querySelectorAll('[data-mdh-hot]').forEach(function (hot) {
        if (hot.hasAttribute('data-mdh-hot-static')) return;
        var limit = Number(hot.dataset.threshold) || 0;
        var left = typeof v.stock === 'number' ? v.stock : 0;
        hot.hidden = !(limit > 0 && left > 0 && left <= limit);
        var c = hot.querySelector('[data-mdh-hot-left]');
        if (c) c.textContent = left;
      });
      if (addBtn) addBtn.disabled = !v.available;
      if (addLabel) {
        addLabel.textContent = v.available
          ? data.addLabel + (data.showPriceInButton ? ', ' + formatMoney(v.price * q, moneyFormat) : '')
          : data.soldOutLabel;
      }
      if (sticky) {
        var sb = sticky.querySelector('button');
        if (sb) { sb.disabled = !v.available; sb.textContent = v.available ? data.addLabel : data.soldOutLabel; }
      }
      syncItems();
    }

    root.querySelectorAll('.mdh-pack input').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        idInput.value = radio.value;
        if (addBtnEl) addBtnEl.dataset.variant = radio.value;
        var v = selected();
        if (v.mediaIndex !== null && v.mediaIndex !== undefined) goTo(v.mediaIndex);
        if (data.updateUrl && window.history && history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url.toString());
        }
        render();
      });
    });

    root.querySelectorAll('[data-mdh-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.dataset.mdhQty === 'plus' ? 1 : -1;
        qtyInput.value = Math.min(99, Math.max(1, qty() + step));
        render();
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', function () { qtyInput.value = qty(); render(); });
    if (addon) addon.addEventListener('change', syncItems);

    if (form) form.addEventListener('submit', syncItems, true);

    if (sticky && addBtn && 'IntersectionObserver' in window) {
      var buy = root.querySelector('.mdh-pdp__buy');
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past);
        sticky.setAttribute('aria-hidden', String(!past));
      });
      io.observe(buy);
      var sbtn = sticky.querySelector('button');
      if (sbtn) sbtn.addEventListener('click', function () { addBtn.click(); });
    }

    render();
    syncGallery();
  }

  /* ---------------- Savings calculator ---------------- */
  function initCalc(root) {
    if (!root || root.dataset.mdhReady) return;
    root.dataset.mdhReady = 'true';
    var d = root.dataset;
    var range = root.querySelector('input[type=range]');
    var out = root.querySelector('output');
    var fmt = d.moneyFormat;
    var el = function (sel) { return root.querySelector(sel); };
    var presets = root.querySelectorAll('[data-mdh-preset]');
    function money(cents) { return formatMoney(Math.round(cents / 100) * 100, fmt).replace(/[.,]00(?=\D*$)/, ''); }
    function calc() {
      var min = Number(range.min), max = Number(range.max), val = Number(range.value);
      range.style.setProperty('--fill', ((val - min) * 100) / (max - min) + '%');
      var weekly = val * 100;
      var yearlyWaste = weekly * 52 * (Number(d.wasteRate) / 100);
      var saved = yearlyWaste * (Number(d.reduction) / 100);
      var weeks = saved > 0 ? Math.max(1, Math.ceil(Number(d.price) / (saved / 52))) : 0;
      out.textContent = money(weekly);
      el('[data-mdh-waste]').textContent = money(yearlyWaste);
      el('[data-mdh-save]').textContent = money(saved);
      var monthText = d.perMonth || '';
      if (monthText) {
        el('[data-mdh-waste-month]').textContent = monthText.replace('[amount]', money(yearlyWaste / 12));
        el('[data-mdh-save-month]').textContent = monthText.replace('[amount]', money(saved / 12));
      }
      el('[data-mdh-payback]').innerHTML = d.paybackTemplate
        .replace('[price]', formatMoney(Number(d.price), fmt))
        .replace('[weeks]', '<strong>' + weeks + ' ' + (weeks === 1 ? d.weekLabel : d.weeksLabel) + '</strong>');
      var bar = el('[data-mdh-weeks-bar]');
      if (bar) bar.style.setProperty('--weeks', Math.min(100, Math.max(4, (weeks / 52) * 100)) + '%');
      presets.forEach(function (b) { b.setAttribute('aria-pressed', String(Number(b.dataset.mdhPreset) === val)); });
    }
    range.addEventListener('input', calc);
    presets.forEach(function (b) {
      b.addEventListener('click', function () { range.value = b.dataset.mdhPreset; calc(); });
    });
    calc();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-mdh-pdp]').forEach(initProduct);
    (scope || document).querySelectorAll('[data-mdh-calc]').forEach(initCalc);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
